import { z } from "zod";

export const Enterprise = z.object({
  accountNumber: z.string(),
  enterpriseID: z.number(),
  name: z.string(),
});

export type Enterprise = z.infer<typeof Enterprise>;
